import { render, staticRenderFns } from "./PortalPageShell.vue?vue&type=template&id=5e8b9e2e&"
import script from "./PortalPageShell.vue?vue&type=script&lang=js&"
export * from "./PortalPageShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports